import { api } from './api';
export const worksApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取作品列表
        getWorks: builder.query({
            query: (params) => ({
                url: '/works',
                params,
            }),
            providesTags: (result) => result
                ? [
                    ...result.items.map(({ id }) => ({ type: 'Work', id })),
                    { type: 'Work', id: 'LIST' },
                ]
                : [{ type: 'Work', id: 'LIST' }],
        }),
        // 获取单个作品详情
        getWork: builder.query({
            query: (id) => `/works/${id}`,
            providesTags: (result, error, id) => [{ type: 'Work', id }],
        }),
        // 点赞作品
        likeWork: builder.mutation({
            query: (id) => ({
                url: `/works/${id}/like`,
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Work', id }],
        }),
        // 取消点赞
        unlikeWork: builder.mutation({
            query: (id) => ({
                url: `/works/${id}/like`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Work', id }],
        }),
        // 分享作品
        shareWork: builder.mutation({
            query: (id) => ({
                url: `/works/${id}/share`,
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Work', id }],
        }),
    }),
});
export const { useGetWorksQuery, useGetWorkQuery, useLikeWorkMutation, useUnlikeWorkMutation, useShareWorkMutation, } = worksApi;
